/**
 * BNM Group LLC — corporate identity data.
 *
 * Verified registered identity applied from the official Georgian company
 * registration extract, limited to CORPORATE identity only:
 *   legal name, legal form, identification code, year established,
 *   registered office (city/country), official channels.
 *
 * By policy, NO personal names are published anywhere on this site — no
 * director, shareholder, founder, owner or beneficial-owner information in
 * pages, SEO metadata, JSON-LD, sitemap or nav.
 *
 * The full registered street/apartment is intentionally NOT published; the
 * registered office is shown publicly as "Tbilisi, Georgia".
 *
 * Current corporate contact always takes precedence over the registration
 * document: website https://bnm.ge and email info@bnm.ge. The private email
 * in the registration extract is intentionally NOT used.
 *
 * KA locale is scaffolded as an English mirror pending Georgian translation.
 */

export const CANONICAL_ORIGIN = "https://bnm.ge";

export const COMPANY = {
  // Verified registered corporate identity (Georgia).
  legalName: "BNM Group LLC",
  legalNameLocal: "შპს BNM Group",
  legalForm: "Limited Liability Company (LLC)",
  idCode: "404945841", // Georgian identification (taxpayer) code
  established: "2012", // established 2012 (registered 28/05/2012)
  status: { en: "Active", ka: "Active" },
  address: {
    // Registered office published as city + country only (no street/apartment).
    street: "",
    city: "Tbilisi",
    country: { en: "Georgia", ka: "Georgia" },
  },
  website: "https://bnm.ge",
  websiteLabel: "bnm.ge",
  email: "info@bnm.ge",
  // Contact fields still to confirm (kept as placeholders):
  pec: "[to be confirmed]",
  phone: "[to be confirmed]",
  phoneHref: "#",
  // Georgian identification code doubles as the taxpayer number:
  taxCode: "404945841",
  // Italy-specific fields — not applicable to a Georgian entity (empty, not displayed):
  vat: "",
  vatIntl: "",
  rea: "",
  registeredWith: "",
  shareCapital: { en: "[to be confirmed]", ka: "[to be confirmed]" },
  // No personal names published — leadership fields intentionally empty:
  chairman: "",
  boardMember: "",
  eoriEU: "",
  eoriUK: "",
  mapsUrl: "#",
  /** Business hours (Asia/Tbilisi) — confirm before launch. */
  businessHours: {
    weekdays: { open: "09:00", close: "18:00" },
    weekend: "closed",
    timezone: "Asia/Tbilisi",
  },
} as const;
